import { AppDomain, Config } from '@browsing/config';

export const getSupportedLanguages = (config: Config) => {
    const appdomains = config.getSwitchUrlAppdomains();
    if (!appdomains) {
        return null;
    }

    const { pathname = '', search = '', hash = '' } = window.location;

    return Object.keys(appdomains).map(appdomainId => ({
        countryCode: config.getCountryCodeForAppdomainId(appdomainId).toUpperCase(),
        url: `//${appdomains[appdomainId as unknown as AppDomain]}${pathname}${search}${hash}`,
        active: String(config.appdomain) === appdomainId,
    }));
};
